import { AuthApi } from "@/api/auth";
import { ForgotPasswordRequest } from "@/api/auth/types";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export const useForgotPassword = () => {
  const { mutate, isPending: isForgotPasswordLoading } = useMutation({
    mutationFn: (body: ForgotPasswordRequest) => AuthApi.forgotPassword(body),
    onSuccess: () => {
      toast.success("Code sent to your email!");
      // No navigation needed as we're handling step changes internally
    },
    onError: (error) => {
      toast.error(error);
    },
  });

  // Wrap the mutate function to accept an onSuccess callback
  const forgotPassword = (body: ForgotPasswordRequest, onSuccess?: () => void) => {
    mutate(body, {
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
      }
    });
  };

  return { forgotPassword, isForgotPasswordLoading };
};
